export default __webpack_public_path__ + "static/media/dotIcon.34d5c72f.svg";